/* CUBE STORE - "Calcola la tua taglia"
   Collega il riquadro guida taglie al configuratore ufficiale CUBE
   (bikesizing.cube.eu). Il codice articolo arriva dal metafield
   custom.codice, stampato in pagina da snippets/price.liquid.

   Parametri dell'URL (il contenuto e' di CUBE, si governa solo da qui):
   - viewMode=cube   -> grafica CUBE: campi squadrati, etichette
                        maiuscole, nessuna intestazione, nessun nome bici
   - color=#0d82c5   -> azzurro della barra annunci per la sagoma
   - titolo = uno spazio, cosi' non compare in nessun caso

   Altezza automatica: il widget pubblica la propria altezza al sito che
   lo ospita (window.parent.postMessage con il solo numero). La ascoltiamo
   e adattiamo il riquadro: niente scorrimento interno, niente tagli.

   Link "Trova un rivenditore": compare solo dopo il calcolo ed e'
   l'ultimo elemento della pagina; lo teniamo fuori vista tagliando gli
   ultimi CROP_PX del riquadro. Due precauzioni:
   - il taglio scatta SOLO quando l'altezza supera quella minima
     osservata (= stato senza risultato), altrimenti taglierebbe il
     pulsante di calcolo;
   - CROP_PX e' misurato sul widget reale (a 396, 420 e 520px di
     larghezza lo spazio tra la fine del disclaimer e il fondo pagina e'
     sempre 65-66px): 60 lascia qualche pixel di margine sotto al
     disclaimer e resta comunque sopra al link.
   L'iframe ha larghezza massima fissa (vedi cube-product.css) proprio
   per garantire che il widget usi sempre la disposizione in colonna,
   l'unica in cui quel link sta in fondo.

   sandbox senza allow-top-navigation: quel link punta a cube.eu con
   target=_parent e porterebbe il cliente fuori dal negozio.

   L'iframe viene creato solo al primo click. */
(function () {
  var ORIGIN = 'https://bikesizing.cube.eu';
  var SRC = ORIGIN + '/iframe/';
  var PARAMS = '/%20/?language=it&color=%230d82c5&viewMode=cube';
  var PANEL_ID = 'cube-sizing-panel';

  var MIN_HEIGHT = 320;
  var MAX_HEIGHT = 2400;
  var CROP_PX = 60;
  var RESULT_DELTA = 40;

  var panel = null;
  var frame = null;
  var baseHeight = 0;

  function applyHeight(height) {
    if (!panel || !frame) return;

    /* la piu' bassa altezza vista e' lo stato senza risultato:
       li' non c'e' nessun link da nascondere */
    if (!baseHeight || height < baseHeight) baseHeight = height;

    var hasResult = height > baseHeight + RESULT_DELTA;
    var visible = hasResult ? height - CROP_PX : height;

    panel.style.height = visible + 'px';
    frame.style.height = height + 'px';
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== ORIGIN) return;

    var height = parseInt(event.data, 10);
    if (!height || height < MIN_HEIGHT || height > MAX_HEIGHT) return;

    applyHeight(height);
  });

  function build() {
    var wrap = document.querySelector('.vb-size-guide');
    if (!wrap) return;

    var button = wrap.querySelector('.vb-size-guide__button');
    if (!button || button.dataset.cubeSizing === '1') return;

    var data = document.querySelector('.cube-sizing-data');
    var code = data ? (data.getAttribute('data-code') || '').trim() : '';

    /* senza codice articolo il configuratore non puo' funzionare:
       meglio non mostrare un tasto che non fa nulla.

       Va nascosto con priorita': il <style> dentro
       blocks/buy-buttons.liquid dichiara .vb-size-guide { display: block
       !important }, e uno stile scritto qui senza priorita' perderebbe.
       Perdeva davvero: sui prodotti senza codice il riquadro restava in
       pagina e il tasto non apriva niente. */
    if (!code) {
      wrap.style.setProperty('display', 'none', 'important');
      return;
    }

    button.dataset.cubeSizing = '1';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', PANEL_ID);

    panel = document.createElement('div');
    panel.className = 'cube-sizing-panel';
    panel.id = PANEL_ID;
    panel.hidden = true;
    wrap.appendChild(panel);

    button.addEventListener('click', function (event) {
      event.preventDefault();

      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.hidden = isOpen;

      if (!isOpen && !frame) {
        frame = document.createElement('iframe');
        frame.src = SRC + encodeURIComponent(code) + PARAMS;
        frame.title = 'Calcola la tua taglia';
        frame.loading = 'lazy';
        frame.setAttribute('scrolling', 'no');
        frame.setAttribute('sandbox', 'allow-scripts allow-forms allow-same-origin');
        panel.appendChild(frame);
      }
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      build();
    });
  }

  function init() {
    build();
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
